export default {
    namespaced: true,
    state: {
        user: 'null',
    },
    mutations: {
        setUser(state, user) {
            state.user = user;
        },
    },
    actions: {
        setUser({ commit }, user) {
            commit('setUser', user);
        },
    },
    getters: {
        user: state => state.user,
    }
};
